import React from "react";
import { ClockCircleOutlined, SyncOutlined, CheckCircleOutlined, ExclamationCircleOutlined, StopOutlined, SwapOutlined, QuestionCircleOutlined } from "@ant-design/icons";

/**
 * 航班状态常量 (对齐后端模型和IATA标准)
 */

// 状态代码
export const FLIGHT_STATUS = {
    SCHEDULED: "SCHEDULED", // 已计划
    DELAYED: "DELAYED", // 延误
    DEPARTED: "DEPARTED", // 已起飞 (替代 ACTIVE 的一部分)
    COMPLETED: "COMPLETED", // 已完成（已经与 ARRIVED 合并）
    DIVERTED: "DIVERTED", // 备降
    REPLACED: "REPLACED", // 被替换 (计划发布时被新计划替换)
    CANCELLED: "CANCELLED", // 已取消 (运行时取消)
    PLAN_CANCELLED: "PLAN_CANCELLED", // 计划取消 (计划发布时确定取消)
};

// 状态显示文本映射
export const FLIGHT_STATUS_LABELS = {
    [FLIGHT_STATUS.SCHEDULED]: "计划",
    [FLIGHT_STATUS.DELAYED]: "延误",
    [FLIGHT_STATUS.DEPARTED]: "飞行中",
    [FLIGHT_STATUS.COMPLETED]: "已完成",
    [FLIGHT_STATUS.DIVERTED]: "备降",
    [FLIGHT_STATUS.REPLACED]: "被替换",
    [FLIGHT_STATUS.CANCELLED]: "已取消",
    [FLIGHT_STATUS.PLAN_CANCELLED]: "计划取消",
};

// 状态颜色映射 (可根据UI风格调整)
export const FLIGHT_STATUS_COLORS = {
    [FLIGHT_STATUS.SCHEDULED]: "#108ee9", // blue
    [FLIGHT_STATUS.DELAYED]: "#faad14", // orange
    [FLIGHT_STATUS.DEPARTED]: "#722ed1", // purple
    [FLIGHT_STATUS.COMPLETED]: "#73d13d", // lighter green
    [FLIGHT_STATUS.DIVERTED]: "#722ed1", // purple
    [FLIGHT_STATUS.REPLACED]: "#666666", // grey
    [FLIGHT_STATUS.CANCELLED]: "#f5222d", // red
    [FLIGHT_STATUS.PLAN_CANCELLED]: "#666666", // grey
    default: "#d9d9d9", // grey for unknown/default
};

// 新增：状态图标映射
export const FLIGHT_STATUS_ICONS = {
    [FLIGHT_STATUS.SCHEDULED]: <ClockCircleOutlined />,
    [FLIGHT_STATUS.DEPARTED]: <SyncOutlined spin />, // 注意：与颜色不完全匹配，组件内用的蓝色+Sync
    [FLIGHT_STATUS.DELAYED]: <ExclamationCircleOutlined />,
    [FLIGHT_STATUS.COMPLETED]: <CheckCircleOutlined />,
    [FLIGHT_STATUS.DIVERTED]: <SwapOutlined />,
    [FLIGHT_STATUS.REPLACED]: <SwapOutlined />,
    [FLIGHT_STATUS.CANCELLED]: <StopOutlined />,
    [FLIGHT_STATUS.PLAN_CANCELLED]: <StopOutlined />,
    default: <QuestionCircleOutlined />,
};

// 默认筛选状态 (监控常用状态，可根据实际需要调整)
export const DEFAULT_FILTER_STATUS = [FLIGHT_STATUS.SCHEDULED, FLIGHT_STATUS.DEPARTED, FLIGHT_STATUS.DELAYED];

// 可筛选的状态选项 (用于下拉框等)
export const FLIGHT_STATUS_OPTIONS = Object.values(FLIGHT_STATUS).map((status) => ({
    value: status,
    label: FLIGHT_STATUS_LABELS[status] || status,
}));
